import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const ERROR_REQUIRED = 'This field is required';
const ERROR_MIN = 'This field is minimum 7 characters';

const getOnlyNumber = value => {
  let numberValue = '';

  const numberReg = /^\d+$/;

  for (let i = 0; i < value.length; i++) {
    if (numberReg.test(value.charAt(i))) {
      numberValue += value.charAt(i);
    }
  }

  return numberValue;
};

const processDefaultValue = (defaultValue, isRequired) => {
  let inputDefaultValue = defaultValue;

  if (!defaultValue) {
    inputDefaultValue = '';
  }

  const numberValue = getOnlyNumber(inputDefaultValue);

  const lengthNumberValue = numberValue.length;

  let value = '';
  let error = '';

  if (lengthNumberValue < 7 && lengthNumberValue > 0) {
    error = ERROR_MIN;
  }

  if (isRequired && lengthNumberValue === 0) {
    error = true;
  }

  if (lengthNumberValue > 3 && lengthNumberValue < 7) {
    value = `${numberValue.slice(0, 3)}-${numberValue.slice(3)}`;
  } else if (lengthNumberValue >= 7) {
    value = `${numberValue.slice(0, 3)}-${numberValue.slice(
      3,
      6
    )}-${numberValue.slice(6)}`;
    error = '';
  } else {
    value = numberValue;
  }

  return {
    value,
    error
  };
};

class PhoneNumberInput extends Component {
  static propTypes = {
    defaultValue: PropTypes.string,
    isRequired: PropTypes.bool,
    onError: PropTypes.func,
    divStyle: PropTypes.any,
    editAble: PropTypes.bool,
    onSubmit: PropTypes.func,
    onCancel: PropTypes.func,
    name: PropTypes.string,
    actionButtonPosition: PropTypes.string,
    ignoreOnBlur: PropTypes.bool
  };

  static defaultProps = {
    defaultValue: '',
    isRequired: false,
    editAble: false,
    ignoreOnBlur: false
  };

  constructor(props) {
    super(props);
    this.defaultState = processDefaultValue(
      props.defaultValue,
      props.isRequired
    );

    this.state = {
      value: this.defaultState.value,
      error: this.defaultState.error
    };
  }

  componentDidMount() {
    if (this.defaultState.error && this.props.onError) {
      this.props.onError(true);
    }
  }

  onKeepCursorPosition = cursor => {
    if (this.input.current !== null) {
      this.input.selectionStart = cursor;
      this.input.selectionEnd = cursor;
    }
  };

  dispatchPropError = status => {
    const { onError } = this.props;

    if (onError) {
      onError(status);
    }
  };

  onChange = e => {
    const { isRequired } = this.props;

    const { value } = e.target;

    const cursor = e.target.selectionStart;

    const inputReg = /^[0-9-]*$/;

    if (inputReg.test(value.slice(-1))) {
      const numberValue = getOnlyNumber(value);

      const lengthNumberValue = numberValue.length;

      if (lengthNumberValue < 7 && lengthNumberValue > 0) {
        this.setState({ error: ERROR_MIN }, () => {
          this.dispatchPropError(true);
        });
      }

      if (isRequired && lengthNumberValue === 0) {
        this.setState({ error: ERROR_REQUIRED }, () => {
          this.dispatchPropError(true);
        });
      }

      if (lengthNumberValue === 0 && !isRequired) {
        this.setState({ error: '' });
      }

      if (lengthNumberValue > 3 && lengthNumberValue < 7) {
        this.setState(
          {
            value: `${numberValue.slice(0, 3)}-${numberValue.slice(3)}`
          },
          () => {
            this.onKeepCursorPosition(cursor === 4 ? cursor + 1 : cursor);
          }
        );
      } else if (lengthNumberValue >= 7) {
        this.setState(
          {
            value: `${numberValue.slice(0, 3)}-${numberValue.slice(
              3,
              6
            )}-${numberValue.slice(6)}`,
            error: ''
          },
          () => {
            this.onKeepCursorPosition(cursor === 8 ? cursor + 1 : cursor);
            this.dispatchPropError(false);
          }
        );
      } else {
        this.setState(
          {
            value: numberValue
          },
          () => {
            this.dispatchPropError(this.state.error ? true : false);
          }
        );
      }
    }
  };

  onFocus = () => {
    const { editAble } = this.props;

    if (editAble) {
      this.setState({
        editing: true
      });
    }
  };

  onBlur = () => {
    const { value, error } = this.state;

    const { defaultValue, onSubmit, name, editAble, ignoreOnBlur } = this.props;

    if (!ignoreOnBlur && editAble) {
      if (value !== defaultValue && !error) {
        onSubmit({ [name]: value });
      }

      this.setState({ editing: false });
    }
  };

  onCancel = () => {
    const { editAble, defaultValue, isRequired, onCancel } = this.props;

    if (editAble) {
      const { value, error } = processDefaultValue(defaultValue, isRequired);
      this.setState(
        {
          editing: false,
          value,
          error
        },
        () => {
          if (onCancel) {
            onCancel();
          }
        }
      );
    }
  };

  onSubmit = () => {
    const { value, error } = this.state;

    const { name, onSubmit } = this.props;

    if (!error) {
      onSubmit({ [name]: value });

      this.setState({ editing: false });
    }
  };

  render() {
    const { value, error, editing } = this.state;

    const { divStyle, actionButtonPosition } = this.props;

    // const inputStyle = error.length > 0 ? { borderColor: '#FF595E' } : {};

    return (
      <div className='phone-input-wrapper' style={divStyle}>
        <input
          ref={ref => {
            this.input = ref;
          }}
          className='form-control'
          type='text'
          value={value}
          placeholder='xxx-xxx-xxxx'
          onChange={this.onChange}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          maxLength={17}
          // style={inputStyle}
          {...this.props}
        />
        {editing && (
          <React.Fragment>
            <button
              key='cancel'
              className={`input-edit-able input-edit-able-cancel input-over-btn ${actionButtonPosition}`}
              id='phone-cancel-btn'
              onMouseDown={this.onCancel}
            >
              <i className='fa fa-close' />
            </button>
            <button
              key='save'
              className={`input-edit-able input-edit-able-save input-over-btn ${actionButtonPosition}`}
              onClick={this.onSubmit}
            >
              <i className='fa fa-check' />
            </button>
          </React.Fragment>
        )}
        {error && (
          <div className='text-danger' style={{ fontSize: 13 }}>
            {error}
          </div>
        )}
      </div>
    );
  }
}

export default PhoneNumberInput;



// WEBPACK FOOTER //
// ./src/components/PhoneNumberInput/index.js